module.exports = __webpack_public_path__ + "img/a12de33.jpg";